<template>
  <div
    class="icon-container elevation-1 d-flex justify-center align-center"
    :style="{ 
      backgroundColor: bgColor, 
      width: size + 'px', 
      height: size + 'px', 
      borderRadius: borderRadius + 'px',
      color: iconColor
    }"
  >
    <v-icon v-if="!isImage" :style="{ color: iconColor }">
      {{ icon }}
    </v-icon>
    <img v-else :src="icon" :height="iconSize" :width="iconSize" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: 'IconContainer',
  props: {
    icon: {
      type: String,
      required: true
    },
    isImage: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 40
    },
    iconSize: {
      type: Number,
      default: 24
    },
    bgColor: {
      type: String,
      default: 'rgba(99, 169, 255, 0.1)'
    },
    iconColor: {
      type: String,
      default: '#63A9FF'
    },
    borderRadius: {
      type: Number,
      default: 10
    },
    alt: {
      type: String,
      default: 'icon'
    }
  }
}
</script>

<style scoped>
.icon-container {
  transition: all 0.3s ease;
}

.icon-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style> 